<p-toast />
<p-confirmDialog />

<section class="w-full">
  <app-chat-layout [detalleAbierto]="detalleAbierto()">
    <app-chat-list
      chatLista
      [conversaciones]="conversaciones()"
      [seleccionadaId]="seleccionadaId()"
      [loading]="loading()"
      [mostrarAcciones]="true"
      (seleccionar)="onSeleccionar($event)"
      (cerrarTodos)="onCerrarTodos()"
    />

    <div chatDetalle class="flex flex-column flex-1 min-h-0">
      @if (seleccionada()) {
        <app-chat-header
          [conversacion]="seleccionada()!"
          [mostrarNivel]="mostrarNivel()"
          [mostrarVolver]="true"
          (volver)="onVolver()"
          (cerrar)="onCerrarChat()"
        />

        @if (seleccionada()!.solicitudes.length > 0) {
          <div class="flex flex-column gap-2 px-3 pt-3">
            @for (solicitud of seleccionada()!.solicitudes; track solicitud.tipo) {
              <app-solicitud-banner
                [solicitud]="solicitud"
                [puedeAlMuelle]="puedeAlMuelle()"
                (accion)="onAccionSolicitud($event)"
              />
            }
          </div>
        }

        <app-chat-messages [mensajes]="seleccionada()!.mensajes" perspectiva="admin" />

        <app-chat-input (enviar)="onEnviar($event)" />
      } @else if (!loading()) {
        <div class="flex flex-1 flex-column align-items-center justify-content-center p-4 text-center">
          <i class="pi pi-comments text-3xl text-color-secondary" aria-hidden="true"></i>
          <p class="mt-3 mb-1 font-medium text-color">No hay chats abiertos</p>
          <p class="m-0 text-sm text-color-secondary">
            Cuando un l&iacute;der env&iacute;e una solicitud, el chat aparece ac&aacute;.
          </p>
        </div>
      }
    </div>
  </app-chat-layout>
</section>

<p-dialog
  [visible]="motivoVisible()"
  (visibleChange)="onMotivoVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '30rem' }"
  [header]="motivoCopy()?.header ?? ''"
>
  <p class="m-0 mb-3 text-sm text-color-secondary">
    Explique el motivo para que al l&iacute;der le quede claro en el chat.
  </p>

  <textarea
    pTextarea
    class="w-full"
    rows="3"
    [ngModel]="motivoTexto()"
    (ngModelChange)="motivoTexto.set($event)"
    placeholder="Motivo"
    aria-label="Motivo"
  ></textarea>

  <div class="flex justify-content-end gap-2 pt-3">
    <p-button
      type="button"
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      (onClick)="cerrarMotivo()"
    />
    <p-button
      type="button"
      [label]="motivoCopy()?.aceptar ?? 'Enviar'"
      icon="pi pi-check"
      [disabled]="motivoInvalido()"
      (onClick)="confirmarMotivo()"
    />
  </div>
</p-dialog>

<p-dialog
  [visible]="avisoLiderVisible()"
  (visibleChange)="onAvisoLiderVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '32rem' }"
  header="Esta persona es líder"
>
  <p class="m-0 text-color">
    <span class="font-semibold">{{ muelleNombre() }}</span>
    es líder y {{ textoDiscipulos() }}.
  </p>
  <p class="mt-3 mb-0 text-sm text-color-secondary">
    ¿Transferimos sus discípulos a otro líder? Si no, quedan sin líder y pasan al muelle,
    disponibles para el resto de los líderes. {{ muelleNombre() }} se envía al muelle en los dos casos.
  </p>

  <div class="flex flex-wrap justify-content-end gap-2 pt-4">
    <p-button
      type="button"
      label="Cancelar"
      severity="secondary"
      [text]="true"
      (onClick)="cancelarMuelle()"
    />
    <p-button
      type="button"
      label="No, dejar sin líder"
      severity="secondary"
      [outlined]="true"
      (onClick)="dejarSinLider()"
    />
    <p-button type="button" label="Sí, transferir" icon="pi pi-users" (onClick)="abrirElegirLider()" />
  </div>
</p-dialog>

<p-dialog
  [visible]="elegirLiderVisible()"
  (visibleChange)="onElegirLiderVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '32rem' }"
  header="Transferir discípulos"
>
  <p class="m-0 mb-3 text-sm text-color-secondary">
    Elegí el líder que va a recibir a los discípulos de {{ muelleNombre() }}. Después,
    {{ muelleNombre() }} se envía al muelle.
  </p>

  <label class="text-sm font-semibold text-color" for="lider-destino">Nuevo líder</label>
  <p-select
    inputId="lider-destino"
    class="mt-1"
    [options]="lideresOpciones()"
    optionLabel="label"
    optionValue="value"
    placeholder="Elegí un líder"
    [filter]="lideresOpciones().length > 6"
    filterPlaceholder="Buscar líder"
    appendTo="body"
    styleClass="w-full mt-1"
    [loading]="cargandoLideres()"
    [ngModel]="liderDestino()"
    (ngModelChange)="liderDestino.set($event)"
    [disabled]="cargandoLideres()"
  />

  @if (!cargandoLideres() && lideresOpciones().length === 0) {
    <p class="mt-2 mb-0 text-sm text-color-secondary">
      No hay otros líderes para recibir a los discípulos. Podés volver y dejarlos sin líder.
    </p>
  }

  <div class="flex justify-content-end gap-2 pt-4">
    <p-button
      type="button"
      label="Volver"
      severity="secondary"
      [outlined]="true"
      (onClick)="volverAlAviso()"
    />
    <p-button
      type="button"
      label="Transferir y enviar"
      icon="pi pi-check"
      [disabled]="!liderDestino()"
      (onClick)="confirmarTransferencia()"
    />
  </div>
</p-dialog>
